import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  image = input<string>('shared-assets/images/noTransactions.png');
  icon = input<string | null>(null);
  title = input<string>('No Results Found');
  subtitle = input<string | null>(null);

  filtersApplied = input(false);
  searchText = input('');

  readonly getSubtitle = computed(() => {
    return this.filtersApplied() || !!this.searchText()
      ? 'No items match your current filters, try adjusting to see more results.'
      : this.subtitle() || 'Make your first changes to see them here.';
  });
}
